import './innerpagehero.css'

function InnerPageHero({title, bgImage}) {
  return (
    <div className="inner-page-hero" style={{backgroundImage: `url(${bgImage})`}}>
      <div className="container">
        <h1>{title}</h1>
      </div>
    </div>
  )
}

export default InnerPageHero